export default __webpack_public_path__ + "img/documentos.5bd8fefe.svg";